"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const basePolicyResponse_1 = __importDefault(require("../basePolicyResponse"));
class BasePolicySummary extends basePolicyResponse_1.default {
    constructor(policy, validationLink, lastModifiedDate, lastModifiedBy) {
        super(policy, lastModifiedDate, lastModifiedBy);
        this.validationLink = validationLink;
    }
}
exports.default = BasePolicySummary;
//# sourceMappingURL=basePolicySummary.class.js.map